<template>
<div id="search-container" >

    <div class="search-wrapper-v2" >

        <div class="search-section search-options" :class="{'open': mobile_filter_open}" >

            <div class="search-options-wrapper">

                <div class="search-el search-heading">
                    <div class="heading-label">Search</div>
                    <div class="heading-actions" @click="toggleMobileFilter" >
                        <div class="close-menu"></div>
                    </div>
                </div>

                <div class="search-el" >
                    <div class="search-opt-heading no-border" 
                        @click="toggleTab('results_matching')"
                        >
                        <div class="search-opt-heading-text" >Show results matching</div>
                        <div class="search-opt-heading-toggle" :class="{'closed': isTabOpen('results_matching') == false}" >
                            <span v-if="isTabOpen('results_matching')" >&mdash;</span>
                            <span v-else >&plus;</span>
                        </div>
                    </div>
                    <transition-collapse>
                    <div class="search-opt-body"
                        v-show="isTabOpen('results_matching')" 
                        >
                        <ul>
                            <li>
                                <label>
                                    <input type="radio" name="results-matching" id="all-matching" 
                                        :value="0" v-model="form.rt" 
                                        @click="resetPage" >
                                    All Search Terms
                                </label>
                            </li>
                            <li>
                                <label>
                                    <input type="radio" name="results-matching" id="any-matching" 
                                        :value="1" v-model="form.rt" 
                                        @click="resetPage" >
                                    Any Search Terms
                                </label>
                            </li>
                        </ul>
                    </div>
                    </transition-collapse>
                </div>

                <div class="search-el border">
                    <div class="search-opt-heading"
                        @click="toggleTab('search')"
                        >
                        <div class="search-opt-heading-text" >Search</div>
                        <div class="search-opt-heading-toggle" :class="{'closed': isTabOpen('search') == false}" >
                            <span v-if="isTabOpen('search')" >&mdash;</span>
                            <span v-else >&plus;</span>
                        </div>
                    </div>
                    <transition-collapse>
                        <div class="search-opt-body"
                            v-show="isTabOpen('search')" 
                            >
                            <input class="fc-input" type="text" name="fact-check-search" 
                                id="fact-check-search" placeholder="Search" v-model="form.k" 
                                @input="resetPage" >
                        </div>
                    </transition-collapse>
                </div>

                <div class="search-el border">
                    <div class="search-opt-heading"
                        @click="toggleTab('date_range')"
                        >
                        <div class="search-opt-heading-text" >Date Range</div>
                        <div class="search-opt-heading-toggle" :class="{'closed': isTabOpen('date_range') == false}" >
                            <span v-if="isTabOpen('date_range')" >&mdash;</span>
                            <span v-else >&plus;</span>
                        </div>
                    </div>
                    <transition-collapse>
                        <div class="search-opt-body"
                            v-show="isTabOpen('date_range')" 
                            >
                        <flat-pickr 
                            v-model="form.dr" class="fc-input" 
                            ref="date_range_input"
                            :config="search_configs.date_configs"
                            name="date_range" id="date_range" placeholder="Date Range" 
                            @onChange="resetPage" 
                            ></flat-pickr>
                        </div>
                    </transition-collapse>
                </div>

                <div class="search-el border">
                    <div class="search-opt-heading"
                        @click="toggleTab('claim_details')"
                        >
                        <div class="search-opt-heading-text" >Claim Details</div>
                        <div class="search-opt-heading-toggle" :class="{'closed': isTabOpen('claim_details') == false}" >
                            <span v-if="isTabOpen('claim_details')" >&mdash;</span>
                            <span v-else >&plus;</span>
                        </div>
                    </div>
                    <transition-collapse>
                        <div class="search-opt-body"
                            v-show="isTabOpen('claim_details')" 
                            >
                            <!-- :style="`max-height: ${((6 * 28) / 2)}px`" -->
                            <div class="checkbox-grid-2"  >
                                
                                <label>
                                    Lacks Evidence
                                    <select name="lack_of_evidence" id="lack_of_evidence" 
                                        v-model="form.lack_of_evidence" class="fc-input" >
                                        <option :value="null" >Any</option>
                                        <option :value="0" >No</option>
                                        <option :value="1" >Yes</option>
                                    </select>
                                </label>
                                <br/>
                                <label>
                                    Misleading
                                    <select name="misleading" id="misleading" 
                                        v-model="form.misleading" class="fc-input" >
                                        <option :value="null" >Any</option>
                                        <option :value="0" >No</option>
                                        <option :value="1" >Yes</option>
                                    </select>
                                </label>
                                <br/>
                                <!-- <div class="checkbox-grid-2" :style="`max-height: ${((form.v.length * 28) / 2)}px`" > -->
                                    <label v-for="(opt, index) in form.reality_basis" :key="`${opt.value}-${index}`" >
                                        <input type="checkbox" name="reality_basis" id="reality_basis" 
                                        v-model="opt.selected" :true-value="true" :false-value="false" 
                                        @click="resetPage" >
                                        {{opt.name}}
                                    </label>
                                <!-- </div> -->

                            </div>
                        </div>
                    </transition-collapse>
                </div>

                <div class="search-el border">
                    <div class="search-opt-heading"
                        @click="toggleTab('claim_verdict')"
                        >
                        <div class="search-opt-heading-text" >Claim Verdict</div>
                        <div class="search-opt-heading-toggle" :class="{'closed': isTabOpen('claim_verdict') == false}" >
                            <span v-if="isTabOpen('claim_verdict')" >&mdash;</span>
                            <span v-else >&plus;</span>
                        </div>
                    </div>
                    <transition-collapse>
                        <div class="search-opt-body"
                            v-show="isTabOpen('claim_verdict')" 
                            >
                            <div class="checkbox-grid-2">
                                <span>Top {{form.v.length}} Verdicts:</span>
                                <!-- <div style="margin-left: 15px;" class="checkbox-grid-2" > -->
                                <div class="checkbox-grid-2" :style="`max-height: ${((form.v.length * 28) / 2)}px`" >
                                    <label v-for="(opt, index) in form.v" :key="`${opt.id}-${index}`" >
                                        <input type="checkbox" name="cv-true" id="cv-true" 
                                        v-model="opt.selected" :true-value="true" :false-value="false" 
                                        @click="resetPage" >
                                        {{opt.name}}
                                    </label>
                                </div>

                            </div>
                        </div>
                    </transition-collapse>
                </div>

                <div class="search-el border">
                    <div class="search-opt-heading"
                        @click="toggleTab('claim_type')"
                        >
                        <div class="search-opt-heading-text" >Claim Type</div>
                        <div class="search-opt-heading-toggle" :class="{'closed': isTabOpen('claim_type') == false}" >
                            <span v-if="isTabOpen('claim_type')" >&mdash;</span>
                            <span v-else >&plus;</span>
                        </div>
                    </div>
                    <transition-collapse>
                        <div class="search-opt-body"
                            v-show="isTabOpen('claim_type')" 
                            >
                            <div class="checkbox-grid-2" :style="`max-height: ${((form.ct.length * 28) / 2)}px`" >
                                <label v-for="(opt, index) in form.ct" :key="index" >
                                    <input type="checkbox" :name="`claim_type-${index}`" 
                                        :id="`claim_type-${index}`" v-model="opt.selected" 
                                        :true-value="true" :false-value="false" 
                                        @click="resetPage" >
                                    {{opt.name}}
                                </label>
                            </div>
                        </div>
                    </transition-collapse>
                </div>

                <div class="search-el border">
                    <div class="search-opt-heading"
                        @click="toggleTab('claim_source')"
                        >
                        <div class="search-opt-heading-text" >Claim Authors</div>
                        <div class="search-opt-heading-toggle" :class="{'closed': isTabOpen('claim_source') == false}" >
                            <span v-if="isTabOpen('claim_source')" >&mdash;</span>
                            <span v-else >&plus;</span>
                        </div>
                    </div>
                    <transition-collapse>
                        <div class="search-opt-body"
                            v-show="isTabOpen('claim_source')" 
                            >
                            <multiselect 
                                v-model="form.cs" 
                                :options="form.claim_sources"
                                :searchable="true"
                                :close-on-select="false"
                                :show-labels="true"
                                :multiple="true"
                                placeholder="Search claim authors"
                                label="name" 
                                track-by="name"
                                @search-change="searchTerm => apiSearchClaimSources(searchTerm)"
                                @select="(selectedOption, id) => {resetPage();}" 
                                ></multiselect>
                        </div>
                    </transition-collapse>
                </div>

                <div class="search-el border">
                    <div class="search-opt-heading"
                        @click="toggleTab('claim_source_type')"
                        >
                        <div class="search-opt-heading-text" >Claim Author Category</div>
                        <div class="search-opt-heading-toggle" :class="{'closed': isTabOpen('claim_source_type') == false}" >
                            <span v-if="isTabOpen('claim_source_type')" >&mdash;</span>
                            <span v-else >&plus;</span>
                        </div>
                    </div>
                    <transition-collapse>
                        <div class="search-opt-body"
                            v-show="isTabOpen('claim_source_type')" 
                            >
                            <div class="checkbox-grid-2">
                                <label v-for="(opt, index) in form.cst" :key="index" >
                                    <input type="checkbox" :name="`claim_type-${index}`" 
                                        :id="`claim_type-${index}`" v-model="opt.selected" 
                                        :true-value="true" :false-value="false" >
                                    {{opt.name}}
                                    <div v-if="opt.children" class="child-options" >
                                        <label v-for="(child, index2) in opt.children" :key="index2" >
                                            <input type="checkbox" :name="`claim_type_child-${index}-${index2}`" 
                                                :id="`claim_type_child-${index}-${index2}`" v-model="child.selected"
                                                :true-value="true" :false-value="false" :disabled="!opt.selected" 
                                                @click="resetPage" >
                                            {{ child.name }}
                                        </label>
                                    </div>
                                </label>
                            </div>
                        </div>
                    </transition-collapse>
                </div>

                <div class="search-el border">
                    <div class="search-opt-heading"
                        @click="toggleTab('fact_check_outlet')"
                        >
                        <div class="search-opt-heading-text" >Fact Check Outlet</div>
                        <div class="search-opt-heading-toggle" :class="{'closed': isTabOpen('fact_check_outlet') == false}" >
                            <span v-if="isTabOpen('fact_check_outlet')" >&mdash;</span>
                            <span v-else >&plus;</span>
                        </div>
                    </div>
                    <transition-collapse>
                        <div class="search-opt-body"
                            v-show="isTabOpen('fact_check_outlet')" 
                            >
                            <div class="checkbox-grid">
                                <label v-for="(opt, index) in form.fc_orgs" :key="index" >
                                    <input type="checkbox" :name="`fc_outlet-${index}`" 
                                        :id="`fc_outlet-${index}`" v-model="opt.selected" 
                                        :true-value="true" :false-value="false" 
                                        @click="resetPage" >
                                    {{opt.name}}
                                </label>
                            </div>
                        </div>
                    </transition-collapse>
                </div>

                <div class="search-el border">
                    <div class="search-opt-heading"
                        @click="toggleTab('fact_check_author')"
                        >
                        <div class="search-opt-heading-text" >Fact Check Author</div>
                        <div class="search-opt-heading-toggle" :class="{'closed': isTabOpen('fact_check_author') == false}" >
                            <span v-if="isTabOpen('fact_check_author')" >&mdash;</span>
                            <span v-else >&plus;</span>
                        </div>
                    </div>
                    <transition-collapse>
                        <div class="search-opt-body"
                            v-show="isTabOpen('fact_check_author')" 
                            >
                            <multiselect 
                                v-model="form.fc_authors" 
                                :options="form.fact_check_authors"
                                :searchable="true"
                                :close-on-select="false"
                                :show-labels="true"
                                :multiple="true"
                                placeholder="Search fact check authors"
                                label="name" 
                                track-by="name"
                                @search-change="searchTerm => apiSearchFactCheckAuthors(searchTerm)"
                                @select="(selectedOption, id) => {resetPage();}" 
                                ></multiselect>
                        </div>
                    </transition-collapse>
                </div>

                <div class="search-el border">
                    <div class="search-opt-heading"
                        @click="toggleTab('tags')"
                        >
                        <div class="search-opt-heading-text" >Tags</div>
                        <div class="search-opt-heading-toggle" :class="{'closed': isTabOpen('tags') == false}" >
                            <span v-if="isTabOpen('tags')" >&mdash;</span>
                            <span v-else >&plus;</span>
                        </div>
                    </div>
                    <transition-collapse>
                        <div class="search-opt-body"
                            v-show="isTabOpen('tags')" 
                            >
                            <multiselect 
                                v-model="form.tags" 
                                :options="form.tag_options"
                                :searchable="true"
                                :close-on-select="false"
                                :show-labels="true"
                                :multiple="true"
                                placeholder="Search tags"
                                label="name" 
                                track-by="name"
                                @search-change="searchTerm => apiSearchTags(searchTerm)"
                                @select="(selectedOption, id) => {resetPage();}" 
                                ></multiselect>
                        </div>
                    </transition-collapse>
                </div>

            </div>

        </div>

        <div class="search-section search-results">

            <div class="mobile-filter">
                <button type="button" class="filter-btn" @click="toggleMobileFilter" >
                    <span>Filter ({{displayOptions.length}})</span>
                </button>

                <div class="results-listing">
                    <div class="result-toggle" @click="decreasePage" >
                        <img v-if="loading_left" class="loader" src="https://www.realclearpolitics.com/asset/img/fact_check/loading.png">
                        <img v-else-if="claims.current_page > 1 && claims.last_page > 1" src="https://www.realclearpolitics.com/asset/img/fact_check/icon-left.png">
                    </div>
                    <div v-if="searching" class="search-placeholder placeholder-glow" >
                        <div class="placeholder"></div>
                    </div>
                    <div v-else >Displaying {{number_format(claims.from)}} to {{number_format(claims.to)}} out of {{number_format(claims.total)}} results</div>
                    <div class="result-toggle" @click="increasePage" >
                        <img v-if="loading_right" class="loader" src="https://www.realclearpolitics.com/asset/img/fact_check/loading.png">
                        <img v-else-if="claims.current_page < claims.last_page" src="https://www.realclearpolitics.com/asset/img/fact_check/icon-right.png">
                    </div>
                </div>
            </div>

            <div class="search-listing-container">

                <div class="opt-label-wrapper">
                    <span v-for="(opt, index) in displayOptions" :key="index" class="opt-label">
                        <span class="opt-label-source">{{opt.label}}:</span>
                        <span class="opt-label-text">{{opt.value}}</span>
                    </span>
                </div>

                <div class="results-listing">
                    <div class="result-toggle" @click="decreasePage" >
                        <img v-if="loading_left" class="loader" src="https://www.realclearpolitics.com/asset/img/fact_check/loading.png">
                        <img v-else-if="claims.current_page > 1 && claims.last_page > 1" src="https://www.realclearpolitics.com/asset/img/fact_check/icon-left.png">
                    </div>
                    <div v-if="searching" class="search-placeholder placeholder-glow" >
                        <div class="placeholder"></div>
                    </div>
                    <div v-else >Displaying {{number_format(claims.from)}} to {{number_format(claims.to)}} out of {{number_format(claims.total)}} results</div>
                    <div class="result-toggle" @click="increasePage" >
                        <img v-if="loading_right" class="loader" src="https://www.realclearpolitics.com/asset/img/fact_check/loading.png">
                        <img v-else-if="claims.current_page < claims.last_page" src="https://www.realclearpolitics.com/asset/img/fact_check/icon-right.png">
                    </div>
                </div>

            </div>

            <div class="search-results-table">
                <!-- v-if="claims.data.length > 0" -->
                <search-results-table 
                    :loading="searching"
                    :claims="claims.data" />
                <!-- <p v-else >No Claims</p> -->
            </div>

            <div class="footer-listing">
                <div class="results-listing">
                    <div class="result-toggle" @click="decreasePage" >
                        <img v-if="loading_left" class="loader" src="https://www.realclearpolitics.com/asset/img/fact_check/loading.png">
                        <img v-else-if="claims.current_page > 1 && claims.last_page > 1" src="https://www.realclearpolitics.com/asset/img/fact_check/icon-left.png">
                    </div>
                    <div v-if="searching" class="search-placeholder placeholder-glow" >
                        <div class="placeholder"></div>
                    </div>
                    <div v-else >Displaying {{number_format(claims.from)}} to {{number_format(claims.to)}} out of {{number_format(claims.total)}} results</div>
                    <div class="result-toggle" @click="increasePage" >
                        <img v-if="loading_right" class="loader" src="https://www.realclearpolitics.com/asset/img/fact_check/loading.png">
                        <img v-else-if="claims.current_page < claims.last_page" src="https://www.realclearpolitics.com/asset/img/fact_check/icon-right.png">
                    </div>
                </div>
            </div>
        </div>

    </div>

</div>
</template>

<script>

/**
 * @see https://www.npmjs.com/package/vue-flatpickr-component
 */
import Flatpickr from 'vue-flatpickr-component';

/**
 * @see https://vue-multiselect.js.org/#sub-getting-started
 */
import Multiselect from 'vue-multiselect';
import SearchResultsTable from './Tables/SearchResultsTable.vue';

import ApiMixin from './ApiMixin.js';
import TransitionCollapse from './TransitionCollapse.vue';

let default_day_range = 150;

import qs from 'querystring';
window.qs = qs;

export default {
    name: 'fact-check-search',
    components: {
        'flat-pickr': Flatpickr,
        'multiselect': Multiselect,
        'search-results-table': SearchResultsTable,
        'transition-collapse': TransitionCollapse,
    },
    mixins: [
        ApiMixin,
    ],
    data() {
        return {
            search_timeout: null,
            searching: false,

            /**
             * Search fields and options
             */
            form: {
                page: 1, // current results page
                rt: 0, // restult type
                k: '', // text query
                dr: '', // date range
                v: [], // top claims verdicts
                ct: [], // claim type categories
                // top_source_types: [],
                cs: [], // selected claim sources (authors)
                claim_sources: [], // claim source options
                cst: [], // claim source types
                fc_orgs: [], // fact check orgs
                fc_authors: [], // fact check authors
                fact_check_authors: [], // fact check author options
                tags: [], // tags
                tag_options: [], // tag options
                lack_of_evidence: null,
                misleading: null,
                reality_basis: [
                    {
                        selected: false,
                        value: 0,
                        name: 'Opinion',
                    },
                    {
                        selected: false,
                        value: 1,
                        name: 'Factual',
                    },
                    {
                        selected: false,
                        value: 2,
                        name: 'Projection',
                    },
                ],
            },

            claims: {
                data: [],
                per_page: 10,
                current_page: 1,
                last_page: 1,
                from: 1,
                to: 10,
                total: 10,
            },

            search_configs: {
                has_search: false,
                advanced_is_open: false,
                loading_sources: false,
                drop_down_configs:{
                    closeOnSelect: true,
                    selectLabel: '',
                    selectedLabel: 'Selected',
                    deselectLabel: 'Selected',
                    placeHolder: 'Click to select one or more',
                },

                //https://chmln.github.io/flatpickr/options/
                date_configs: {
                    dateFormat : "Y-m-d",
                    altFormat: 'F j, Y',
                    altInput: true,
                    mode: 'range',
                    minDate: "2017-10-23",
                    maxDate: dayjs().format('YYYY-MM-DD'),
                    defaultDate: [
                        dayjs().subtract(default_day_range, 'days').format('YYYY-MM-DD'),
                        dayjs().format('YYYY-MM-DD'),
                    ],
                },

                quick_date_range_val: 0,
                display_quick_date_range: false,
    
                relative_date_string: '',
                relative_date_string_short: '',
                update_url_timeout: 0,
                init_load_source: '',
                init_load_with_custom_time: false,
                loading_search: true,
                show_percent_matching_claims: false,
                auto_search: true,
                search_updated_timeout: 10, // milliseconds
                temp_search_choice:{},
                updating_query_params: false,
            },

            loading_left: false,
            loading_right: false,

            tabs_tracker: {},

            mobile_filter_open: false,
        };
    },
    created(){
        // this.$set(this, 'opts', Object.assign(this.opts, JSON.parse(JSON.stringify(this.search))));
        this.form.dr = this.search.date_range;
        this.getFormInitData();
    },
    computed: {

        displayOptions(){
            let opts = [];

            let match = (this.form.rt == 0) ? 'All' : 'Any';
            opts.push({label: 'Match', value: match});
            
            if( this.form.k ){
                opts.push({label: 'Search', value: this.form.k});
            }
            
            let dates   = this.form.dr.split(' to ');
            let date = dayjs(dates[0]).format('M/D/YY')+' to '+dayjs(dates[1]).format('M/D/YY');
            opts.push({label: 'Date Range', value: date});

            let v = this.form.v
                            .filter(v => {
                                if(v.selected){
                                    return v;
                                }
                            });

            for (let i = 0; i < v.length; i++) {
                opts.push({label: 'Verdict', value: v[i].name});
            }

            let ct = this.form.ct
                            .filter(ct => {
                                if(ct.selected){
                                    return ct;
                                }
                            });

            for (let i = 0; i < ct.length; i++) {
                opts.push({label: 'Claim Type', value: ct[i].name});
            }

            for (let i = 0; i < this.form.cs.length; i++) {
                opts.push({label: 'Claim Author', value: this.form.cs[i].name});
            }

            let cst = this.form.cst
                            .filter(v => {
                                if(v.selected){
                                    return v;
                                }
                            })
                            .map(v => {

                                if(v.children){

                                    let selected_childen = v.children.filter(c => {
                                        if(c.selected){
                                            return c;
                                        }
                                    });

                                    if( selected_childen.length > 0 ){
                                        v.selected_childen = selected_childen;
                                        return v;
                                    }
                                }

                                return v;
                            });

            for (let i = 0; i < cst.length; i++) {
                let cst_name = cst[i].name;

                if( cst[i].selected_childen ){

                    if( cst[i].selected_childen.length > 0 ){
                        cst_name += ": ";

                        for (let y = 0; y < cst[i].selected_childen.length; y++) {

                            if( cst[i].selected_childen[y].selected ){

                                cst_name += cst[i].selected_childen[y].name;
                                if( (y+1) < cst[i].selected_childen.length ){
                                    cst_name += ", ";
                                }
                            }
                        }
                    }
                }

                opts.push({label: 'Claim Author Type', value: cst_name});
            }

            let fc_orgs = this.form.fc_orgs
                            .filter(v => {
                                if(v.selected){
                                    return v;
                                }
                            });

            for (let i = 0; i < fc_orgs.length; i++) {
                opts.push({label: 'Outlet', value: fc_orgs[i].name});
            }

            for (let i = 0; i < this.form.fc_authors.length; i++) {
                opts.push({label: 'Author', value: this.form.fc_authors[i].name});
            }

            for (let i = 0; i < this.form.tags.length; i++) {
                opts.push({label: 'Tag', value: this.form.tags[i].name});
            }

            if(this.form.lack_of_evidence !== null){
                let yes_no = (this.form.lack_of_evidence) ? 'Yes' : 'No';
                opts.push({label: 'Lacks Evidence', value: yes_no});
            }

            if(this.form.misleading !== null){
                let yes_no = (this.form.misleading) ? 'Yes' : 'No';
                opts.push({label: 'Misleading', value: yes_no});
            }

            let reality_basis = this.form.reality_basis
                            .filter(v => {
                                if(v.selected){
                                    return v;
                                }
                            });

            for (let i = 0; i < reality_basis.length; i++) {
                opts.push({label: 'Claim Is', value: reality_basis[i].name});
            }

            return opts;
        },

        /**
         * Search query object
         */
        searchQuery(){

            let opts = {};

            let dates   = this.form.dr.split(' to ');
            opts.dr     = this.form.dr;
            opts.sd     = dates[0];
            opts.ed     = dates[1];

            opts.rt = this.form.rt;

            let v = this.form.v
                            .filter(v => {
                                if(v.selected){
                                    return v;
                                }
                            })
                            .map(v => {
                                return parseInt(v.id);
                            });

            if( v.length > 0 ){
                opts.v = v;
            }

            let ct = this.form.ct
                            .filter(ct => {
                                if(ct.selected){
                                    return ct;
                                }
                            })
                            .map(ct => {
                                return parseInt(ct.id);
                            });

            if( ct.length > 0 ){
                opts.ct = ct;
            }

            let cs = this.form.cs
                            .map(v => {
                                return parseInt(v.id);
                            });

            if( cs.length > 0 ){
                opts.cs = cs;
            }

            let cst = this.form.cst
                            .filter(v => {
                                if(v.selected){
                                    return v;
                                }
                            })
                            .map(v => {

                                if(v.children){
                                    let selected_childen = v.children.filter(c => {
                                        if(c.selected){
                                            return c;
                                        }
                                    })
                                    .map(c => {
                                        return {id: parseInt(c.id), type: c.type};
                                    });

                                    if( selected_childen.length > 0 ){
                                        return {id: parseInt(v.id), children: selected_childen};
                                    }
                                }

                                return {id: parseInt(v.id)};
                            });

            if( cst.length > 0 ){
                opts.cst = cst;
            }

            let fc_orgs = this.form.fc_orgs
                            .filter(v => {
                                if(v.selected){
                                    return v;
                                }
                            })
                            .map(v => {
                                return parseInt(v.id);
                            });

            if( fc_orgs.length > 0 ){
                opts.fc_orgs = fc_orgs;
            }

            let fc_authors = this.form.fc_authors
                                .map(v => {
                                    return parseInt(v.id);
                                });

            if( fc_authors.length > 0 ){
                opts.fc_authors = fc_authors;
            }

            let tags = this.form.tags
                                .map(v => {
                                    return parseInt(v.id);
                                });

            if( tags.length > 0 ){
                opts.tags = tags;
            }

            if( this.form.k ){
                opts.k = this.form.k;
            }

            if(this.form.lack_of_evidence !== null){
                opts.lack_of_evidence = this.form.lack_of_evidence;
            }

            if(this.form.misleading !== null){
                opts.misleading = this.form.misleading;
            }

            opts.reality_basis = this.form.reality_basis
                            .filter(v => {
                                if(v.selected){
                                    return v;
                                }
                            })
                            .map(v => {
                                return v.value;
                            });

            opts.page = this.form.page;

            return opts;
        },

        /**
         * Query string version of options
         */
        searchQueryString(){
            // return qs.stringify(this.searchQuery);
            return JSON.stringify(this.searchQuery);
        },

    },
    methods: {

        toggleMobileFilter(){
            this.mobile_filter_open = !this.mobile_filter_open;
        },

        toggleTab(tab){
            if( typeof this.tabs_tracker[tab] == 'undefined' ){
                this.$set(this.tabs_tracker, tab, true);
            }

            this.tabs_tracker[tab] = (this.tabs_tracker[tab] == true) ? false : true;
        },

        isTabOpen(tab){
            return typeof this.tabs_tracker[tab] == 'undefined' || this.tabs_tracker[tab] == true;
        },

        resetPage(){
            this.form.page = 1;
        },

        decreasePage(){
            this.loading_left = true;
            this.loadPage(this.form.page - 1);
        },

        increasePage(){
            this.loading_right = true;
            this.loadPage(this.form.page + 1);
        },

        loadPage(page){
            console.log("PAGE", page);

            if(page > this.claims.last_page){
                return;
            }

            if(page < 1){
                return;
            }

            if( page == this.claims.current_page ){
                return;
            }

            this.form.page   = page;

            this.$nextTick(() => {
                this.searchDb();
            });
        },

        async getFormInitData(){

            let opts        = {};
            let data_opts   = {};

            // data to send to the server on page load to get the initial data for the form
            if( Object.keys(this.$route.query).length > 0 ){
                opts = JSON.parse(this.$route.query.opts);
                console.log("QUERY FORM", JSON.parse(this.$route.query.opts));

                if(opts.cs){
                    data_opts.cs = opts.cs;
                    delete opts.cs;
                }
                
                if(opts.fc_authors){
                    data_opts.fc_authors = opts.fc_authors;
                    delete opts.fc_authors;
                }
                
                if(opts.tags){
                    data_opts.tags = opts.tags;
                    delete opts.tags;
                }

                data_opts.misleading = (typeof opts.misleading != 'undefined') ? opts.misleading : null;
                data_opts.lack_of_evidence = (typeof opts.lack_of_evidence != 'undefined') ? opts.lack_of_evidence : null;
            }
            
            console.log("DATA OPTIONS", data_opts);

            let res = await this.getData(data_opts, 'fcr_search_form_data');

            let data = res.data.data;
            
            // setup form data with server data
            let form = {
                v: data.top_claims_verdicts,
                ct: data.claim_type_categories,
                fc_orgs: data.fact_check_orgs,
                cst: data.source_types,
                cs: data.onload_sources,
                claim_sources: data.top_sources,
                fc_authors: data.onload_fc_authors,
                fact_check_authors: data.top_fc_authors,
                tags: data.onload_tags,
                tag_options: data.top_tags,
                misleading: data_opts.misleading,
                lack_of_evidence: data_opts.lack_of_evidence,
            };

            if( Object.keys(opts).length > 0 ){
                form = this.parseOpts(opts, form);
                console.log("QUERY FORM", form, this.$route.query.opts);
            }

            this.$set(this, 'form', Object.assign(this.copy(this.form), form));

            this.$nextTick(() => {
                /**
                 * Search after vue updtes with options set
                 */
                this.searchDb();

                /**
                 * Init watcher after options received and initial db search is started
                 */
                this.initFormWatcher();
            });
        },

        async apiSearchClaimSources(searchTerm){

            if( !searchTerm ){
                return;
            }

            let res = await this.getData({term: searchTerm}, 'fcr_search_claim_sources');
            this.form.claim_sources   = res.data.data.fcr_search_claim_sources;
        },

        async apiSearchFactCheckAuthors(searchTerm){

            if( !searchTerm ){
                return;
            }

            let res = await this.getData({term: searchTerm}, 'fcr_search_authors');
            this.form.fact_check_authors   = res.data.data.fcr_search_authors;
        },
        
        async apiSearchTags(searchTerm){

            if( !searchTerm ){
                return;
            }

            let res = await this.getData({term: searchTerm}, 'fcr_search_tags');
            this.form.tag_options   = res.data.data.fcr_search_tags;
        },

        async searchDb(){
            if(this.searching){
                return;
            }

            this.searching = true;
            let res = await this.getData(this.copy(this.searchQuery), 'fcr_search_data');
            this.$set(this, 'claims', res.data.data.claims_data);
            this.$router.replace({path: this.$route.path+'?opts='+this.searchQueryString});

            this.searching = false;
            this.loading_left = false;
            this.loading_right = false;
        },

        parseOpts(opts, form){

            console.log("OPTS", opts);

            if(opts.v){
                console.log("OPTS V", opts.v);
                for (let index = 0; index < opts.v.length; index++) {
                    let value = opts.v[index];
                    let value_index = form.v.map(x => parseInt(x.id)).indexOf(value);
                    console.log("opts V", value, value_index, form.v[value_index], form.v.length);
                    if( value_index > -1 ){
                        form.v[value_index].selected = true;
                        console.log("opts V SET AS TRUE", form.v[value_index], form.v[value_index].selected);
                    }
                }

                delete opts.v;
            }

            if(opts.ct){
                console.log("OPTS CT", opts.ct);
                for (let index = 0; index < opts.ct.length; index++) {
                    let value = opts.ct[index];
                    let value_index = form.ct.map(x => parseInt(x.id)).indexOf(value);
                    console.log("opts CT", value, value_index, form.ct[value_index], form.ct.length);
                    if( value_index > -1 ){
                        form.ct[value_index].selected = true;
                        console.log("opts CT SET AS TRUE", form.ct[value_index], form.ct[value_index].selected);
                    }
                }

                delete opts.ct;
            }

            if(opts.cst){
                console.log("OPTS CST", opts.cst);
                for (let index = 0; index < opts.cst.length; index++) {
                    let value = opts.cst[index];
                    let value_index = form.cst.map(x => parseInt(x.id)).indexOf(value.id);
                    console.log("opts CST", value, value_index, form.cst.length);
                    if( value_index > -1 ){
                        form.cst[value_index].selected = true;
                        console.log("opts CST SET AS TRUE", form.cst[value_index], form.cst[value_index].selected);

                        // do children
                        if( value.children && form.cst[value_index].children ){
                            for (let index_2 = 0; index_2 < value.children.length; index_2++) {
                                let child = value.children[index_2];
                                let children = form.cst[value_index].children.filter(c => {
                                    if( parseInt(c.id) == parseInt(child.id) ){
                                        return c;
                                    }
                                });

                                console.log("opts CST CHILDREN", child, children, children.length);

                                if( children.length > 0 ){
                                    let child_index = children.map(x => x.type).indexOf( child.type );
                                    console.log("opts CST CHILDREN INDEX", child_index);

                                    if( child_index > - 1 ){
                                        form.cst[value_index].children[child_index].selected = true;
                                        console.log("opts CST CHILDREN SET AS TRUE", form.cst[value_index].children[child_index]);
                                    }
                                }
                            }
                        }
                    }
                }

                delete opts.cst;
            }

            if(opts.fc_orgs){
                console.log("OPTS FCR_ORG", opts.fc_orgs);
                for (let index = 0; index < opts.fc_orgs.length; index++) {
                    let value = opts.fc_orgs[index];
                    let value_index = form.fc_orgs.map(x => parseInt(x.id)).indexOf(value);
                    console.log("opts FCR_ORG", value, value_index, form.fc_orgs[value_index], form.fc_orgs.length);
                    if( value_index > -1 ){
                        form.fc_orgs[value_index].selected = true;
                        console.log("opts FCR_ORG SET AS TRUE", form.fc_orgs[value_index], form.fc_orgs[value_index].selected);
                    }
                }

                delete opts.fc_orgs;
            }

            if(opts.reality_basis){
                console.log("OPTS REALITY_BASIS", opts.reality_basis);
                for (let index = 0; index < opts.reality_basis.length; index++) {
                    let value = opts.reality_basis[index];
                    let value_index = this.form.reality_basis.map(x => parseInt(x.value)).indexOf(value);
                    console.log("opts REALITY_BASIS", value, value_index, this.form.reality_basis[value_index], this.form.reality_basis.length);
                    if( value_index > -1 ){
                        this.form.reality_basis[value_index].selected = true;
                        console.log("opts REALITY_BASIS SET AS TRUE", this.form.reality_basis[value_index], this.form.reality_basis[value_index].selected);
                    }
                }

                delete opts.reality_basis;
            }

            return Object.assign(opts, form);
        },

        copy(data){
            return JSON.parse(JSON.stringify(data));
        },

        initFormWatcher(){
            this.$watch('searchQuery', (newValue) => {
                clearTimeout(this.search_timeout);

                if(this.searching){
                    return;
                }

                this.$nextTick(() => {
                    if(this.searching){
                        return;
                    }

                    this.search_timeout = setTimeout(() => {
                        if(this.searching){
                            return;
                        }

                        this.searchDb();
                    }, 1000);
                });
            });
        },

    },
}
</script>

<style lang="scss">
@import 'flatpickr/dist/flatpickr.css';
@import 'flatpickr/dist/themes/airbnb.css';
@import "vue-multiselect/dist/vue-multiselect.min.css";
#search-container{

    .results-listing {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .result-toggle {
            margin: 0px 6px 0px;
            padding: 3px 4px 0px 5px;
            border-radius: 5px;
            cursor: pointer;

            &:hover{
                background-color: #ccc;
            }

            img {
                max-width: 18px;

                &.loader{
                    animation: rotation 1s infinite linear;
                }
            }
        }

        .search-placeholder {
            width: 200px;

            .placeholder{
                width: 100%;
            }
        }
    }

    .search-wrapper-v2{
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        .search-section{

            &.search-options{
                display: none;
                position: fixed;
                top: 56px;
                left: 0;
                width: 100vw;
                height: calc(100vh - 56px);
                background-color: #fff;
                z-index: 999;
                overflow-y: scroll;

                &.open{
                    display: block;
                }

                @media screen and (min-width: 601px){
                    top: 76px;
                    height: calc(100vh - 77px);
                }

                @media screen and (min-width: 1024px){
                    &{
                        position: initial;
                        top: initial;
                        left: initial;
                        width: initial;
                        height: initial;
                        overflow-y: initial;

                        display: block;
                        margin-right: 20px;
                        flex-basis: 30%;
                        min-width: 300px;
                        border: 1px solid #e1e4e8;
                    }
                }
            }

            &.search-results{
                flex-basis: 100%;

                @media screen and (min-width: 1024px){
                    &{
                        flex-basis: 70%;
                    }
                }

                .mobile-filter{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    @media screen and (min-width: 1024px){
                        &{
                            display: none;
                        }
                    }

                    .filter-btn{
                        display: inline-block;
                        margin-bottom: 0;
                        font-weight: 700;
                        text-align: center;
                        vertical-align: middle;
                        cursor: pointer;
                        background-image: none;
                        border: 1px solid transparent;
                        white-space: nowrap;
                        transition-duration: .1s;
                        transition-property: border,box-shadow,outline, background;
                        transition-timing-function: cubic-bezier(.4,0,.2,1);
                        -webkit-font-smoothing: antialiased;
                        padding: 8px 16px;
                        font-size: 14px;
                        line-height: 1.5;
                        border-radius: 22.5px;
                        -webkit-user-select: none;
                        -moz-user-select: none;
                        -ms-user-select: none;
                        user-select: none;

                        color: #414c58;
                        /* background: linear-gradient(#fff,#f8f8f8); */
                        border-color: #cfd4da;
                        box-shadow: 0 1px 1px 0 rgb(0 0 0 / 10%);

                        &:hover{
                            color: #414c58;
                            background: linear-gradient(#f8f8f8,#fff);
                            box-shadow: inset 0 1px 1px 0 rgb(0 0 0 / 10%);
                        }
                    }

                    .results-listing{
                        display: flex;

                        @media screen and (min-width: 1024px){
                            &{
                                display: none;
                            }
                        }
                    }
                }

                .search-listing-container {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    .opt-label-wrapper{
                        .opt-label{
                            padding: 8px 16px;
                            border: 1px solid transparent;
                            border-color: #cfd4da;
                            box-shadow: 0 1px 1px 0 rgb(0 0 0 / 10%);

                            .opt-label-source{

                            }

                            .opt-label-text{
                                vertical-align: initial;
                            }
                        }
                    }

                    .results-listing{
                        display: none;

                        @media screen and (min-width: 1024px){
                            &{
                                display: flex;
                            }
                        }
                    }
                }
            }

            .search-el{
                margin-bottom: 10px;

                &.search-heading {
                    background-color: #ddd;
                    padding: 10px;
                    font-weight: 600;
                    font-size: 1.2em;

                    display: flex;
                    justify-content: space-between;

                    position: sticky;
                    top: 0;
                    z-index: 999;

                    .heading-actions{
                        padding: 12px 15px;
                        cursor: pointer;

                        .close-menu{
                            cursor: pointer;

                            @media screen and (min-width: 1024px){
                                &{
                                    display: none;
                                }
                            }

                            &::before,
                            &::after{
                                position: absolute;
                                top: 5px;
                                right: 25px;
                                content: ' ';
                                height: 33px;
                                width: 2px;
                                background-color: rgb(166, 166, 166);

                                &:hover{
                                    background-color: #e85b00;
                                }
                            }

                            &::before{
                                transform: rotate(45deg);
                            }

                            &::after{
                                transform: rotate(-45deg);
                            }
                        }
                    }
                }

                .search-opt-heading{
                    display: flex;
                    justify-content: space-between;
                    padding: 16px;
                    border-top: 1px solid #e1e4e8;
                    cursor: pointer;

                    &.no-border{
                        border-top: none;
                    }

                    .search-opt-heading-text{
                        font-weight: 600;
                    }

                    .search-opt-heading-toggle{
                        width: 8px;
                        text-align: center;
                        // margin-right: 8px;
                        color: #e85b00;
                        top: 0;
                        line-height: 0;
                        align-self: center;

                        &.closed{
                            color: #1ba504;
                        }
                    }
                }

                .search-opt-body{
                    padding: 0px 16px;
                    padding-bottom: 16px;
                }

                .checkbox-grid{
                    display: flex;
                    justify-content: flex-start;
                    flex-direction: row;
                    flex-wrap: wrap;

                    & > *{
                        flex-basis: 150px;
                        margin-bottom: 5px;
                    }

                    .child-options{
                        display: flex;
                        justify-content: flex-start;
                        flex-direction: column;
                        margin-left: 20px;
                    }
                }

                .checkbox-grid-2 {
                    display: flex;
                    justify-content: flex-start;
                    flex-direction: column;
                    flex-wrap: wrap;
                    max-height: 450px;

                    & > *{
                        margin-bottom: 5px;
                    }

                    .child-options{
                        display: flex;
                        justify-content: flex-start;
                        flex-direction: column;
                        margin-left: 20px;
                    }
                }
            }

        }

    }

    ul{
        padding-inline-start: 0px;
        margin-block: 0px;
    }

    .block{
        display: block;
    }

    .fc-input{
        width: 100%;
        height: 36px;
        padding: 6px 12px;
        background-color: #fff;
        background-image: none;
        border: 1px solid #cfd4da;
        border-radius: 4px;
        box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
        transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
        box-sizing: border-box;
    }

    .footer-listing{
        display: flex;
        justify-content: center;
    }
}
</style>